import { Col, Flex, Row } from 'antd';
import { ErrorBox } from '~/app/components/common/Error/ErrorBox';
import { Loader } from '~/app/components/common/Loader/Loader';
import { PenaltyBreakdownCard } from '~/app/components/dashboard/PenaltyBreakdownCard/PenaltyBreakdownCard';
import { ProgressStatCard } from '~/app/components/dashboard/ProgressStatCard/ProgressStatCard';
import { PortfolioPageHeader } from './components/PortfolioPageHeader/PortfolioPageHeader';
import { PropertiesTableCard } from './components/PropertiesTableCard/PropertiesTableCard';
import type { PortfolioPageViewProps } from './PortfolioPage.types';

export function PortfolioPageView(props: PortfolioPageViewProps) {
  const {
    isLoading,
    isError,
    errorTitle,
    errorMessage,
    pageTitle,
    scopeLabel,
    generateReportLabel,
    attentionStat,
    complianceStat,
    claimablePenalties,
    penaltyExposure,
    propertiesTitle,
    searchPlaceholder,
    searchValue,
    onSearchChange,
    attentionFilterLabel,
    attentionFilterActive,
    onAttentionFilterChange,
    propertiesColumns,
    propertiesRows,
    alertMessage,
    showingLabel,
    pageLabel,
    prevPageAriaLabel,
    nextPageAriaLabel,
    page,
    pageCount,
    onPageChange,
    onGenerateReport,
  } = props;

  if (isLoading && !attentionStat) {
    return <Loader />;
  }

  if (isError) {
    return <ErrorBox title={errorTitle} description={errorMessage} />;
  }

  if (
    !attentionStat ||
    !complianceStat ||
    !claimablePenalties ||
    !penaltyExposure
  ) {
    return <Loader />;
  }

  return (
    <div className="app-page om-dashboard">
      <Flex vertical gap={24}>
        <PortfolioPageHeader
          title={pageTitle}
          scopeLabel={scopeLabel}
          generateReportLabel={generateReportLabel}
          onGenerateReport={onGenerateReport}
        />

        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <ProgressStatCard {...attentionStat} />
          </Col>
          <Col xs={24} md={12}>
            <ProgressStatCard {...complianceStat} />
          </Col>
        </Row>

        <Row gutter={[16, 16]} align="stretch">
          <Col xs={24} lg={12} style={{ display: 'flex' }}>
            <div style={{ width: '100%' }}>
              <PenaltyBreakdownCard {...claimablePenalties} />
            </div>
          </Col>
          <Col xs={24} lg={12} style={{ display: 'flex' }}>
            <div style={{ width: '100%' }}>
              <PenaltyBreakdownCard {...penaltyExposure} />
            </div>
          </Col>
        </Row>

        <PropertiesTableCard
          title={propertiesTitle}
          searchPlaceholder={searchPlaceholder}
          searchValue={searchValue}
          onSearchChange={onSearchChange}
          attentionFilterLabel={attentionFilterLabel}
          attentionFilterActive={attentionFilterActive}
          onAttentionFilterChange={onAttentionFilterChange}
          columns={propertiesColumns}
          rows={propertiesRows}
          alertMessage={alertMessage}
          showingLabel={showingLabel}
          pageLabel={pageLabel}
          prevPageAriaLabel={prevPageAriaLabel}
          nextPageAriaLabel={nextPageAriaLabel}
          page={page}
          pageCount={pageCount}
          onPageChange={onPageChange}
        />
      </Flex>
    </div>
  );
}
